module.exports = __webpack_public_path__ + "assets/img/customerService-3f9d3bc3.png";